import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import TopBar from '../components/layout/TopBar';
import Sidebar from '../components/layout/Sidebar';
import AnalyticsDashboard from '../components/AnalyticsDashboard';
import { useAuthStore } from '../stores/authStore';

export default function AnalyticsPage() {
  const navigate = useNavigate();
  const { user } = useAuthStore();
  const [theme, setTheme] = useState<'dark' | 'light'>('dark');
  const [sidebarOpen, setSidebarOpen] = useState(true);

  useEffect(() => {
    const saved = localStorage.getItem('fm-theme') as 'dark' | 'light' | null;
    if (saved) {
      setTheme(saved);
      document.documentElement.setAttribute('data-theme', saved);
    }
  }, []);

  const toggleTheme = () => {
    const next = theme === 'light' ? 'dark' : 'light';
    setTheme(next);
    localStorage.setItem('fm-theme', next);
    document.documentElement.setAttribute('data-theme', next);
  };

  return (
    <div style={{ display: 'flex', height: '100vh', overflow: 'hidden', background: 'var(--bg)' }}>
      <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)}>
        <button
          onClick={() => navigate('/')}
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            padding: '10px 14px',
            background: 'transparent',
            border: 'none',
            borderRadius: '8px',
            textAlign: 'left',
            fontSize: '13px',
            color: 'var(--text-muted)',
            cursor: 'pointer',
            fontFamily: 'inherit',
            width: '100%'
          }}
          onMouseOver={(e) => {
            e.currentTarget.style.background = 'var(--surface2)'
            e.currentTarget.style.color = 'var(--text)'
          }}
          onMouseOut={(e) => {
            e.currentTarget.style.background = 'transparent'
            e.currentTarget.style.color = 'var(--text-muted)'
          }}
        >
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" style={{ width: '14px', height: '14px' }}>
            <path d="M19 12H5M12 5l-7 7 7 7"/>
          </svg>
          Back to Agent
        </button>
      </Sidebar>

      <main style={{ flex: 1, display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
        <TopBar
          sidebarOpen={sidebarOpen}
          onToggleSidebar={() => setSidebarOpen(true)}
          theme={theme}
          onToggleTheme={toggleTheme}
          user={user}
        />

        <div style={{ flex: 1, overflowY: 'auto', padding: '20px 32px' }}>
          <h1 style={{ margin: '0 0 16px 0', fontSize: '24px', fontWeight: 700 }}>
            Analytics
          </h1>
          <AnalyticsDashboard />
        </div>
      </main>
    </div>
  );
}
